import { EProofOfDeliveryType } from '../enums/pod.enum';

export const PROOF_OF_DELIVERY_TYPE = {
    [EProofOfDeliveryType.NONE]: EProofOfDeliveryType.NONE,
    [EProofOfDeliveryType.PHOTO]: EProofOfDeliveryType.PHOTO,
    [EProofOfDeliveryType.CODE]: EProofOfDeliveryType.CODE,
};
